import firebase from './firebase'
import ApiBase from './ApiBase'

const TOKEN_MAX_CACHED_MIN = 60 * 24 * 7

class UserApi extends ApiBase {
  constructor () {
    super()
    this._defineCallback('token_changed')
    this.user = null
    this.twToken = null
    this.twSecret = null
    // init firebase login process
    firebase.auth().getRedirectResult().then((result) => {
      if (result.credential) {
        this.user = result.user
        this.twToken = result.credential.accessToken
        this.twSecret = result.credential.secret
        this._trigger('token_changed')
        const twCredential = {
          twtoken: this.twToken,
          twsecret: this.twSecret
        }
        const cacheKey = `token:${this.user.uid}`
        this.lscache.set(cacheKey, twCredential, TOKEN_MAX_CACHED_MIN)
        const db = firebase.firestore()
        db.collection('user-credentials').doc(result.user.uid).set(twCredential)
      }
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        if (!this.user) {
          this.user = user
        }
        if (!this.twToken || this.twSecret) {
          const uid = user.uid
          const cacheKey = `token:${uid}`
          const cachedCredential = this.lscache.get(cacheKey)
          if (cachedCredential) {
            this.twToken = cachedCredential.twtoken
            this.twSecret = cachedCredential.twsecret
            this._trigger('token_changed')
          } else {
            const db = firebase.firestore()
            db.collection('user-credentials').doc(uid).get().then((snap) => {
              const doc = snap.exists ? snap.data() : {}
              this.twToken = doc.twtoken
              this.twSecret = doc.twsecret
              this._trigger('token_changed')
              this.lscache.set(cacheKey, {twtoken: this.twToken, twsecret: this.twSecret}, TOKEN_MAX_CACHED_MIN)
            })
          }
        }
      }
    })
  }
  loginWithTwitter () {
    const provider = new firebase.auth.TwitterAuthProvider()
    firebase.auth().signInWithRedirect(provider)
  }
  /**
   * @return {Promise}
   */
  logout () {
    return firebase.auth().signOut().then(() => {
      this.user = null
      this.twToken = null
      this.twSecret = null
      this._trigger('token_changed')
      this.lscache.flush()
      return null
    })
  }
  getToken () {
    return new Promise((resolve, reject) => {
      if (this.twToken && this.twSecret) {
        resolve({twToken: this.twToken, twSecret: this.twSecret})
      } else {
        const tokenChangHandler = this.on('token_changed', () => {
          if (!this.twToken || !this.twSecret) { return }
          this.off('token_changed', tokenChangHandler)
          resolve({twToken: this.twToken, twSecret: this.twSecret})
        })
      }
    })
  }
  /**
   * @return {Promise}
   */
  getLoginStatus () {
    return new Promise((resolve, reject) => {
      const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
        unsubscribe()
        resolve(!!user)
      })
    })
  }

  get uid () { return this.user ? this.user.uid : null }
  get uname () { return this.user ? this.user.displayName : null }
  get twUid () { return this.user ? this.user.providerData[0].uid : null }
}
export default new UserApi()



// WEBPACK FOOTER //
// ./src/api/UserApi.js